export const GOLF_ACITIVITY = "GOLF_ACITIVITY";
export const USER_FEED = "USER_FEED";
